/**
 * Returns true if the store is currently paused for fulfilment.
 * Uses UTC dates to avoid timezone inconsistencies.
 */
export const isStorePaused = () => {
  const now = new Date()

  // Pause starts at midnight UK time (GMT)
  const pauseStart = new Date("2026-01-04T00:00:00Z")

  const pauseEnd = new Date("2026-03-14T00:00:00Z") // Reopens March 14th

  return now >= pauseStart && now < pauseEnd
}

export const storePausedMessage =
  "We're taking a short break and have temporarily paused shipping. You're welcome to browse — ordering reopens on March 14th."
